import { Option } from '../effectif/option.model';
export class InsertDocOption {
  constructor(pOption: Option | null = null, pOrigin: string | null = null, pRelation: string | null = null, pEffectifsSelected: Array<string> | null = null) {
    if (pOption)
      this.Option = pOption;
    if (pOrigin)
      this.Origin = pOrigin;
    if (pRelation)
      this.Relation = pRelation;
    if (pEffectifsSelected)
      this.EffectifsSelected = pEffectifsSelected;
  }
  public Option: Option
  public Origin: string;
  public Relation: string;
  public EffectifsSelected: Array<string>;
}
